import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import {
  AgentsCta,
  AgentsFaq,
  AgentsHero,
  BuilderSection,
  ResponseModesSection,
  TeamAnatomySection,
} from '@/features/agents-marketing/components'
import { agentsFaqs } from '@/features/agents-marketing/data/agentsContent'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'
import {
  getBreadcrumbSchema,
  getFAQSchema,
  renderJsonLd,
} from '@/lib/structured-data'

export const Route = createFileRoute('/agents')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/agents']),
    links: generateLinks(routeSEO['/agents']),
  }),
  component: AgentsPage,
})

function AgentsPage() {
  return (
    <div className="relative min-h-screen flex flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      {/* Structured Data: the FAQ schema is built from the same list the
          page renders, so the two can't drift apart. */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: renderJsonLd(getFAQSchema([...agentsFaqs])),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: renderJsonLd(
            getBreadcrumbSchema([
              { name: 'Home', url: '/' },
              { name: 'Agent Teams', url: '/agents' },
            ]),
          ),
        }}
      />

      <Header />

      <main className="flex flex-col">
        <AgentsHero />
        <TeamAnatomySection />
        <ResponseModesSection />
        <BuilderSection />
        <AgentsFaq />
        <AgentsCta />
      </main>

      <Footer />
    </div>
  )
}
